/* 46b19bbfbc8688b17d9dc19ed5d8ed8828140d8a
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEmptyCartMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateEmptyCartMutation = { __typename?: 'Mutation', createEmptyCart?: string | null };

export type AddSimpleProductsToCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.AddSimpleProductsToCartInput>;
}>;


export type AddSimpleProductsToCartMutation = { __typename?: 'Mutation', addSimpleProductsToCart?: { __typename?: 'AddSimpleProductsToCartOutput', cart: { __typename?: 'Cart', id: string, items?: Array<{ __typename?: 'BundleCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'ConfigurableCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'DownloadableCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'SimpleCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'VirtualCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | null> | null } } | null };

export type AddConfigurableProductsToCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.AddConfigurableProductsToCartInput>;
}>;


export type AddConfigurableProductsToCartMutation = { __typename?: 'Mutation', addConfigurableProductsToCart?: { __typename?: 'AddConfigurableProductsToCartOutput', cart: { __typename?: 'Cart', id: string, items?: Array<{ __typename?: 'BundleCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'ConfigurableCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'DownloadableCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'SimpleCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | { __typename?: 'VirtualCartItem', product: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null } } | null> | null } } | null };

export type UpdateCartItemsMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UpdateCartItemsInput>;
}>;


export type UpdateCartItemsMutation = { __typename?: 'Mutation', updateCartItems?: { __typename?: 'UpdateCartItemsOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type RemoveItemFromCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RemoveItemFromCartInput>;
}>;


export type RemoveItemFromCartMutation = { __typename?: 'Mutation', removeItemFromCart?: { __typename?: 'RemoveItemFromCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type MergeCartsMutationVariables = Types.Exact<{
  sourceCartId: Types.Scalars['String']['input'];
  destinationCartId: Types.Scalars['String']['input'];
}>;


export type MergeCartsMutation = { __typename?: 'Mutation', mergeCarts: { __typename?: 'Cart', id: string } };


export const CreateEmptyCartDocument = gql`
    mutation CreateEmptyCart {
  createEmptyCart
}
    `;
export type CreateEmptyCartMutationFn = Apollo.MutationFunction<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>;

/**
 * __useCreateEmptyCartMutation__
 *
 * To run a mutation, you first call `useCreateEmptyCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmptyCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmptyCartMutation, { data, loading, error }] = useCreateEmptyCartMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateEmptyCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>(CreateEmptyCartDocument, options);
      }
export type CreateEmptyCartMutationHookResult = ReturnType<typeof useCreateEmptyCartMutation>;
export type CreateEmptyCartMutationResult = Apollo.MutationResult<CreateEmptyCartMutation>;
export type CreateEmptyCartMutationOptions = Apollo.BaseMutationOptions<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>;
export const AddSimpleProductsToCartDocument = gql`
    mutation AddSimpleProductsToCart($input: AddSimpleProductsToCartInput) {
  addSimpleProductsToCart(input: $input) {
    cart {
      id
      items {
        product {
          id
          sku
        }
      }
    }
  }
}
    `;
export type AddSimpleProductsToCartMutationFn = Apollo.MutationFunction<AddSimpleProductsToCartMutation, AddSimpleProductsToCartMutationVariables>;

/**
 * __useAddSimpleProductsToCartMutation__
 *
 * To run a mutation, you first call `useAddSimpleProductsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSimpleProductsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSimpleProductsToCartMutation, { data, loading, error }] = useAddSimpleProductsToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSimpleProductsToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddSimpleProductsToCartMutation, AddSimpleProductsToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSimpleProductsToCartMutation, AddSimpleProductsToCartMutationVariables>(AddSimpleProductsToCartDocument, options);
      }
export type AddSimpleProductsToCartMutationHookResult = ReturnType<typeof useAddSimpleProductsToCartMutation>;
export type AddSimpleProductsToCartMutationResult = Apollo.MutationResult<AddSimpleProductsToCartMutation>;
export type AddSimpleProductsToCartMutationOptions = Apollo.BaseMutationOptions<AddSimpleProductsToCartMutation, AddSimpleProductsToCartMutationVariables>;
export const AddConfigurableProductsToCartDocument = gql`
    mutation AddConfigurableProductsToCart($input: AddConfigurableProductsToCartInput) {
  addConfigurableProductsToCart(input: $input) {
    cart {
      id
      items {
        product {
          id
          sku
        }
      }
    }
  }
}
    `;
export type AddConfigurableProductsToCartMutationFn = Apollo.MutationFunction<AddConfigurableProductsToCartMutation, AddConfigurableProductsToCartMutationVariables>;

/**
 * __useAddConfigurableProductsToCartMutation__
 *
 * To run a mutation, you first call `useAddConfigurableProductsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConfigurableProductsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConfigurableProductsToCartMutation, { data, loading, error }] = useAddConfigurableProductsToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddConfigurableProductsToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddConfigurableProductsToCartMutation, AddConfigurableProductsToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddConfigurableProductsToCartMutation, AddConfigurableProductsToCartMutationVariables>(AddConfigurableProductsToCartDocument, options);
      }
export type AddConfigurableProductsToCartMutationHookResult = ReturnType<typeof useAddConfigurableProductsToCartMutation>;
export type AddConfigurableProductsToCartMutationResult = Apollo.MutationResult<AddConfigurableProductsToCartMutation>;
export type AddConfigurableProductsToCartMutationOptions = Apollo.BaseMutationOptions<AddConfigurableProductsToCartMutation, AddConfigurableProductsToCartMutationVariables>;
export const UpdateCartItemsDocument = gql`
    mutation UpdateCartItems($input: UpdateCartItemsInput) {
  updateCartItems(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type UpdateCartItemsMutationFn = Apollo.MutationFunction<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>;

/**
 * __useUpdateCartItemsMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemsMutation, { data, loading, error }] = useUpdateCartItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>(UpdateCartItemsDocument, options);
      }
export type UpdateCartItemsMutationHookResult = ReturnType<typeof useUpdateCartItemsMutation>;
export type UpdateCartItemsMutationResult = Apollo.MutationResult<UpdateCartItemsMutation>;
export type UpdateCartItemsMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>;
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($input: RemoveItemFromCartInput) {
  removeItemFromCart(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type RemoveItemFromCartMutationFn = Apollo.MutationFunction<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;

/**
 * __useRemoveItemFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromCartMutation, { data, loading, error }] = useRemoveItemFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveItemFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument, options);
      }
export type RemoveItemFromCartMutationHookResult = ReturnType<typeof useRemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationResult = Apollo.MutationResult<RemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;
export const MergeCartsDocument = gql`
    mutation MergeCarts($sourceCartId: String!, $destinationCartId: String!) {
  mergeCarts(
    source_cart_id: $sourceCartId
    destination_cart_id: $destinationCartId
  ) {
    id
  }
}
    `;
export type MergeCartsMutationFn = Apollo.MutationFunction<MergeCartsMutation, MergeCartsMutationVariables>;

/**
 * __useMergeCartsMutation__
 *
 * To run a mutation, you first call `useMergeCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCartsMutation, { data, loading, error }] = useMergeCartsMutation({
 *   variables: {
 *      sourceCartId: // value for 'sourceCartId'
 *      destinationCartId: // value for 'destinationCartId'
 *   },
 * });
 */
export function useMergeCartsMutation(baseOptions?: Apollo.MutationHookOptions<MergeCartsMutation, MergeCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCartsMutation, MergeCartsMutationVariables>(MergeCartsDocument, options);
      }
export type MergeCartsMutationHookResult = ReturnType<typeof useMergeCartsMutation>;
export type MergeCartsMutationResult = Apollo.MutationResult<MergeCartsMutation>;
export type MergeCartsMutationOptions = Apollo.BaseMutationOptions<MergeCartsMutation, MergeCartsMutationVariables>;